import React, { useState, useEffect } from "react";
import TextTransition, { presets } from "react-text-transition";
import { SiGithub, SiInstagram, SiLinkedin } from "react-icons/si";
import { HiLocationMarker } from "react-icons/hi";
import { FaCity } from "react-icons/fa";
import { Parallax } from "react-scroll-parallax";
import { motion } from "framer-motion";
import Background1 from "../Assets/background-hero.svg"
import Yahya from "../Assets/y-transformed.png"

const Texts = ["' Cloud Analyst '", "../ Network Engineer", "{ Developer }"];

function Hero() {
  const [indexs, setIndexs] = useState(0);

  useEffect(() => {
    const intervalId = setTimeout(
      () => setIndexs((index) => (index + 1) % Texts.length),
      3000
    );
    return () => clearTimeout(intervalId);
  }, [indexs]);

  return (
    <div id="hero" className="relative z-0 w-full flex sm:h-screen md:h-screen h-screen lg:h-screen sm:flex-col md:flex-col">
      <div className="w-1/2 sm:h-1/2 sm:w-full md:w-full h-full bg-gradient-to-br from-gray-950 to-black md:h-1/2 flex-col pt-20 flex z-0 items-center justify-center text-cyan-400 p-10">
        <div className="flex flex-col items-center py-20 justify-center text-center">
          <h1 className="xl:text-[45px] text-3xl md:text-3xl sm:text-3xl font-[rekind] tracking-wide">
            Greetings, I'm <span className="font-bold">Yahya</span>
          </h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="text-3xl md:text-2xl sm:text-xl font-[rekind] mt-4 w-full"
          >
            <TextTransition
              springConfig={presets.wobbly}
              direction="down"
              className="text-gray-400 text-center align-middle justify-center"
            >
              {Texts[indexs]}
            </TextTransition>
          </motion.div>

          {/* Location Information */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2, ease: "easeInOut" }}
            className="flex items-center justify-center space-x-2 mt-4 text-white"
          >
            <HiLocationMarker className="text-2xl text-cyan-400" />
            <span className="text-lg">Riyadh,</span>
            <span className="text-lg">Saudi Arabia</span>
          </motion.div>

          <div className="flex space-x-12 mt-10 font-extrabold sm:text-3xl md:text-4xl text-[40px] items-stretch">
            <motion.a
              href="https://www.instagram.com/solo_perfecto24"
              aria-label="Instagram"
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <SiInstagram className="hover:text-cyan-400 text-white transition-transform" />
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/in/yahya24"
              aria-label="LinkedIn"
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <SiLinkedin className="hover:text-cyan-400 text-white transition-transform" />
            </motion.a>
            <motion.a
              href="https://www.github.com/TUNKSTUN"
              aria-label="GitHub"
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <SiGithub className="hover:text-cyan-400 text-white transition-transform" />
            </motion.a>
          </div>
        </div>
      </div>

      <div className="w-1/2 sm:h-screen sm:w-full md:w-full z-30 md:h-[300px] h-full bg-black sm:bg-white md:bg-white text-black text-[100px] relative overflow-hidden">
        <img
          src={Background1}
          alt="background-image"
          className="absolute inset-0 w-[1000px] sm:h-auto md:h-auto h-full object-cover sm:object-scale-down sm:rotate-90 md:rotate-90 right-0 top-0"
        />
        <motion.img
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          src={Yahya}
          alt="hero-picture"
          className="xl:max-w-xl sm:max-w-[350px] md:max-w-[300px] lg:max-w-md h-auto bg-transparent right-0 bottom-0 z-10 absolute"
        />
      </div>
    </div>
  );
}

export default Hero;